import * as moment from 'moment';
import { Moment } from 'moment';
import { Chart } from 'chart.js';
import { configLineChart } from '../shared/charts/line/line-chart.config';

/**
 * Mostly taken from https://github.com/cyberbeat/ChartJSTimescaleFillWithZerosPlugin/blob/35e67281662c4a7603346d50c9aae3ba13eafb29/FillScatteredTimeScaleDataPlugin.js
 */
const fillScatteredTimeScaleDataPlugin = {
  beforeUpdate(chart) {
    if (!chart.options.scales) {
      return;
    }

    const timeAxis = chart.options.scales.xAxes[0].time;

    if (!timeAxis || !timeAxis.fillGapsWithZeros) {
      return;
    }

    for (let i = 0; i < chart.data.datasets.length; i++) {
      const set = chart.data.datasets[i];

      if (!set.data.length) {
        continue;
      }

      let min = moment()
        .subtract(30, 'days')
        .startOf('day');
      let max = moment();
      const hash = {};

      for (let j = 0; j < set.data.length; j++) {
        // assume x is a Moment object
        const currentTimeOnX = set.data[j].x;

        const val = moment(set.data[j].x, timeAxis.parser);

        if (!min || min.diff(val) > 0) {
          min = val;
        }

        if (!max || max.diff(val) < 0) {
          max = val;
        }

        hash[currentTimeOnX] = 1;
      }

      for (const val: Moment = min; max.diff(val) > 0; val.add(1, timeAxis.unit)) {
        const value = val.format();

        if (!hash[value]) {
          set.data.push({ x: moment(value), y: 0 });
        }
      }

      set.data.sort((a, b) => (moment(a.x).diff(b.x) < 0 ? -1 : 1));
    }
  }
};

Chart.pluginService.register(fillScatteredTimeScaleDataPlugin);

export const callVolumeChartConfig = {
  lineChartOptions: {
    ...configLineChart.lineChartOptions,
    scales: {
      yAxes: configLineChart.lineChartOptions.scales.yAxes,
      xAxes: [
        {
          type: 'time',
          time: {
            unit: 'day',
            displayFormats: {
              day: 'M/D/YYYY'
            },
            min: moment().subtract(30, 'days'),
            fillGapsWithZeros: true
          },
          gridLines: {
            display: false
          }
        }
      ]
    }
  },
  lineChartType: 'line'
};
